import { UpsellBanner } from './UpsellBanner';

// TODO: in v9, move styled() from UpsellBanner.jsx to here
export var StyledUpsellBanner = UpsellBanner;